const colors = {
  main: 'rgb(239, 13, 51)',
}

export default colors
